/**
 * Copyright (c) NCR Terafina
 **/
import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { BrowserRouter as Router, Switch, NavLink, Link } from 'react-router-dom';
import './App.scss';
import Redoc from './Redoc';
import Swagger from './Swagger';
import GuardedRoute from './GuardedRoute';
import * as Icon from 'react-bootstrap-icons';
/**
 * The app routing component
 *
 */
export default function Home() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div>
        <Navbar sticky="top" bg="dark" variant="dark">
          <Container fluid>
            <Navbar.Brand as={Link} to="/">
              <img
                src="./tf-logo.png"
                width="80"
                height="40"
                className="d-inline-block align-top"
                alt="Terafina logo"
              />
            </Navbar.Brand>
            <Nav className="me-auto">
              <NavLink className="nav-link" to="/">
                Redoc
              </NavLink>
              <NavLink className="nav-link" to="/swagger">
                Swagger
              </NavLink>
            </Nav>
            <Nav>
              <a
                href="./postman_collection.json"
                download="postman_collection.json"
                target="_blank"
                rel="noreferrer"
              >
                <Button size="sm" variant="outline-secondary">
                  <Icon.Download /> <img src="./getpostman-icon.svg" width="35" height="35" />{' '}
                  Collection
                </Button>
              </a>
            </Nav>
            )
          </Container>
        </Navbar>
        <Container className="px-0" fluid>
          <Switch>
            <GuardedRoute path="/swagger">
              <Swagger />
            </GuardedRoute>
            <GuardedRoute path="/">
              <Redoc />
            </GuardedRoute>
          </Switch>
        </Container>
      </div>
    </Router>
  );
}
